import axios from "@/axios.js"


export default {
  
    login({commit},payload){
        return new Promise((resolve,reject) => {

           axios.post('api/auth/login',payload)
           .then(function (response){
            
            localStorage.setItem('token', response.data.token)
            localStorage.setItem('limited', true)

            commit('UPDATE_USER_INFO', response.data.user,{ root: true }) 
            axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
            
            // check if admin limited or not
            JSON.parse(localStorage.getItem('userInfo')).roles.forEach(role=>{
              if (role.name=="admin") {
                localStorage.setItem('limited', false)
              }
            })
            ///
            
            resolve(response);
           })
           
           .catch(function (error) {
            //handle error
            
            reject(error);
          });
        })
    },

    register({},payload){
        return new Promise((resolve,reject) => {
           axios.post('api/auth/register',payload)
           .then(function (response){
              resolve(response)
           })
           .catch(function (error) {
            //handle error
              reject(error);
          });
        })
    },

    // firebase FCM
    storeFcmToken({},payload){
      return new Promise((resolve,reject)=>{
        axios.post('api/auth/update-fcm-token',payload)
        .then((response)=>{
          resolve(response)
        })
        .catch((error)=>{
          reject(error)
        })
      })
      
    },
    logout({commit}){
      return new Promise((resolve, reject) => {
        axios.post('api/auth/logout')
          .then(function () {
              resolve()
          })
          .catch(function () {
            reject
          })
      })
    },
}
